/*
 * @Date: 2019-08-22 10:34:52
 * @LastEditors: x
 * @LastEditTime: 2021-09-29 17:21:20
 */
//获取浏览器参数
const getQueryString = name => {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  let r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  };
  return null;
}

//验证safari无痕浏览
const isValidSeamless = () => {
  // if (window.openDatabase) {
  //   try {
  //     window.openDatabase(null, null, null, null);
  //   } catch (_) {
  //     alert("Safari无痕浏览影响PEAR PRO的下载安装，请关闭无痕模式后下载。");
  //     return true
  //   }
  // } else {
  //   alert("Safari无痕浏览影响PEAR PRO的下载安装，请关闭无痕模式后下载。");
  //   return true
  // }
  // try {
  //   window.openDatabase(null, null, null, null)
  // } catch (n) {
  //   alert("Safari无痕浏览影响PEAR PRO的下载安装，请关闭无痕模式后下载。");
  //   return true
  // }
  // alert("Safari无痕浏览影响PEAR PRO的下载安装，请关闭无痕模式后下载。");
  // return true
}

//国际区号列表
const areaList = [
  {
    title: 'China',
    type: 0,
    areaShort: 'CN',
    areaCode: 86
  },
  {
    title: 'America',
    type: 1,
    areaShort: 'US',
    areaCode: 1
  },
  {
    title: 'Japan',
    type: 2,
    areaShort: 'JP',
    areaCode: 81
  },
  {
    title: 'Korea',
    type: 3,
    areaShort: 'KOR',
    areaCode: 82
  },
  {
    title: 'HongKong',
    type: 4,
    areaShort: 'HK',
    areaCode: 852
  },
  {
    title: 'TaiWan',
    type: 5,
    areaShort: 'TW',
    areaCode: 886
  },
  {
    title: 'Philippines',
    type: 6,
    areaShort: 'PH',
    areaCode: 63
  },
  {
    title: 'Australian',
    type: 7,
    areaShort: 'Aus',
    areaCode: 61
  },
  {
    title: 'Spain',
    type: 8,
    areaShort: 'ESP',
    areaCode: 34
  }
]

// 国际电话正则验证
const countryTelReg = (code, tel) => {
  code = parseInt(code)
  tel = code + tel
  console.log(tel)
  switch (code) {
    case 86:
      // 中国
      return /^(\+?0?86\-?)?1[3456789]\d{9}$/.test(tel)
      break
    case 886:
      // 台湾
      return /^(\+?886\-?|0)?9\d{8}$/.test(tel)
      break
    case 852:
      // 香港
      return /^(\+?852\-?)?[569]\d{3}\-?\d{4}$/.test(tel)
      break
    case 1:
      // 美国
      //12014799186
      console.log(/^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/.test(tel))
      return /^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/.test(tel)
      break
    case 63:
      // 菲律宾
      return /^(\+?0?63\-?)?9\d{9}$/.test(tel)
      break
    case 81:
      // 日本
      return /^(\+?81|0)\-?0?[789]0[\-]?\d{1,4}[\-]?\d{4}$/.test(tel)
      break
    case 853:
      // 澳门
      return /^(\+?0?853\-?)?6\d{7}$/.test(tel)
      break
    case 82:
      // 韩国
      return /^(\+?0?82\-?)?010\d{8}$/.test(tel)
      break
    case 61://澳大利亚
      return /^(\+?61|0)4\d{8}$/.test(tel)
      break
    case 34://西班牙
      return /^(\+?34)?(6\d{1}|7[1234])\d{7}$/.test(tel)
      break 
  }
}

// 判断数组，对象是否为空
const isEmptyObject = (e) => {  
  var t;  
  for (t in e)  
      return !1;
  return !0;
}

const u = navigator.userAgent.toLowerCase()
const isAndroid = u.indexOf('android') > -1 || u.indexOf('adr') > -1 // android终端
const isIpad = u.indexOf('ipad') > -1 || u.indexOf('macintosh') > -1 && 'ontouchend' in document;
const isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || u.indexOf('iphone') > -1 ||  u.indexOf('ipod') > -1 || isIpad

export default {
  getQueryString,
  isValidSeamless,
  isAndroid,
  isIos,
  areaList,
  countryTelReg
}
export {
  isEmptyObject
}



// WEBPACK FOOTER //
// ./src/libs/util.js